import React, { PropsWithChildren } from "react";

export const LayoutBuilderIO: React.FC<PropsWithChildren> = ({ children }) => {
  return <>{children}</>;
};
